import { useCallback, useRef, useState } from 'react'

import dayjs, { Dayjs } from 'dayjs'
import styled from 'styled-components'
import { v4 as uuid } from 'uuid'

import { FormControlProps } from '../FormControl/util'
import Input from '../Input/Input'

const StyledInput = styled(Input)`
  cursor: text;
  &::-webkit-calendar-picker-indicator {
    margin: 0;
    padding: 0;
  }
`

type Props = FormControlProps & {
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onValueChange: (value: Dayjs | undefined) => void
  value: Dayjs | null | undefined
}
const TimeInput = ({
  ariaLabel,
  caption,
  errorMessage,
  id: propId,
  isInvalid,
  isRequired,
  label,
  onBlur,
  onValueChange,
  value,
  tooltip,
  width,
}: Props) => {
  const [id] = useState(propId ?? uuid())
  const inputRef = useRef<HTMLInputElement>(null)

  const formatTimeForUserInteraction = useCallback(
    (time: Dayjs | null | undefined) => time?.format('HH:mm') ?? '',
    []
  )
  const [inputText, setInputText] = useState(formatTimeForUserInteraction(value))

  const handleBlur = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      setInputText(formatTimeForUserInteraction(value))
      onBlur?.(e)
    },
    [formatTimeForUserInteraction, onBlur, value]
  )

  const handleValueChange = useCallback(
    (text: string) => {
      setInputText(text)
      const newValue = dayjs(text, 'HH:mm')
      if (!newValue.isValid()) {
        return
      }
      onValueChange(newValue)
    },
    [onValueChange]
  )

  return (
    <StyledInput
      {...(label ? { label } : { ariaLabel: ariaLabel || '' })}
      caption={caption}
      errorMessage={errorMessage}
      id={id}
      isInvalid={isInvalid}
      isRequired={isRequired}
      onBlur={handleBlur}
      onValueChange={handleValueChange}
      ref={inputRef}
      tooltip={tooltip}
      type="time"
      value={inputText}
      width={width}
    />
  )
}

export default React.memo(TimeInput)
